import { useCallback } from "react";
import { toast, ToastOptions, Id } from "react-toastify";

type NotificationSeverity = "success" | "error" | "info" | "warning";

const useNotification = () => {
  const showNotification = useCallback(
    (message: string, severity: NotificationSeverity): Id => {
      const options: ToastOptions = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      };

      switch (severity) {
        case "success":
          return toast.success(message, options);
        case "error":
          return toast.error(message, options);
        case "info":
          return toast.info(message, options);
        case "warning":
          return toast.warning(message, options);
        default:
          return toast(message, options);
      }
    },
    []
  );

  const hideNotification = useCallback((toastId?: Id) => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  }, []);

  return { showNotification, hideNotification };
};

export default useNotification;
